import { BrowserRouter ,Routes ,Route } from 'react-router-dom';
import ProfilePage from './Profile/profilePage2';
import Login from './Account/Login'
import EditProfilePage from './EditProfile/EditProfilePage'
import Cookies from 'js-cookie';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UTMListAndForm from './utm/UTMForm';
import UtmManager from './utm/UtmValue';





function App() {

  
  let UserToken = Cookies.get('UserSpecialToken');

  if(!UserToken){
  return (
   <BrowserRouter>
   <div className='toast-container'>
   <ToastContainer />

   </div>

   <Routes>
   <Route path='/' element={<Login/>}  />
   <Route path='/ProfileEdit' element={<Login/>}  />
   <Route path='/Login' element={<Login/>}  />
   <Route path='/Profile/:encryptedId' element={<ProfilePage/>}  />
   </Routes>
   </BrowserRouter>
  );
  }
  else if(UserToken){
    return (
     <BrowserRouter>
 <div className='toast-container'>
   <ToastContainer />

   </div>
     <Routes>
     <Route path='/' element={<EditProfilePage/>}  />
     <Route path='/Login' element={<EditProfilePage/>}  />
     <Route path='/ProfileEdit' element={<EditProfilePage/>}  />
     <Route path='/Profile/:encryptedId' element={<ProfilePage/>}  />
     <Route path='/UTMListAndForm' element={<UTMListAndForm/>}  />
     <Route path='/valueutm' element={<UtmManager/>}  />


     </Routes>
     </BrowserRouter>
    );
    }
}

export default App;
